import { render, staticRenderFns } from "./ProfesorHorario.vue?vue&type=template&id=d3ef8e2c&scoped=true"
import script from "./ProfesorHorario.vue?vue&type=script&lang=js"
export * from "./ProfesorHorario.vue?vue&type=script&lang=js"
import style0 from "./ProfesorHorario.vue?vue&type=style&index=0&id=d3ef8e2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3ef8e2c",
  null
  
)

export default component.exports